import { Component, OnInit, ViewChild } from '@angular/core';

import { NotifierService } from 'angular-notifier';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observacao } from '../../../shared/models/observacao';
import { AssociadoObservacaoService } from '../../../core/services/associado-observacao.service';
import { AssociadoService } from '../../../core/services/associado.service';

@Component({
  selector: 'app-dados-observacao',
  templateUrl: './dados-observacao.component.html',
  styleUrls: ['./dados-observacao.component.css']
})
export class DadosObservacaoComponent implements OnInit {

  @ViewChild('associadoObservacaoForm') formValues;

  form: FormGroup;
  breadCrumb;
  me;
  carregando: boolean;
  codigo_pessoa: any;
  observacoes: Observacao;
  carregando_salvar: boolean;
  carregando_finalizar: boolean;
  codigo_observacao: any;

  constructor(private formBuilder: FormBuilder,
              private routerParam: ActivatedRoute,
              private router: Router,
              private observacaoService: AssociadoObservacaoService,
              private associadoService: AssociadoService,
              private notifierService: NotifierService) { 

              this.codigo_pessoa = this.routerParam.snapshot.params.id;

  }

  ngOnInit() {
    this.breadCrumb = [ 
      {nome: "Home", caminho: "/dashboard"},
      {nome: "Associado", caminho: "/associado-listar"}
    ];
    
    this.form = this.formBuilder.group({
      descricao: [null],
    });
    
    this.obterObservacoes();
  }

  limpar() {
    this.form.reset();
    this.codigo_observacao = null;
  }

  carregar(codigo_observacao): void {
    this.carregando = false;
    this.observacaoService.find(codigo_observacao).subscribe((data: Observacao) => {
      this.codigo_observacao = data.codigo_observacao;
      this.form.patchValue({
        descricao: data.descricao
      });
      this.carregando = true;
    });
  }

  obterObservacoes() {
    this.carregando = false;
    this.observacaoService.list(this.codigo_pessoa)
    .subscribe((data: Observacao) => {
      this.observacoes = data;
      this.carregando = true;
    });        
  }

  definirCodigo(codigo) {
    this.codigo_observacao = codigo;
  }

  apagar(codigo_observacao):void {
    this.observacaoService.delete(codigo_observacao).subscribe((data) => {
      this.obterObservacoes();
      this.notifierService.notify( 'success', 'Registro DELETADO com sucesso.' );
    }, (error) => {
      this.notifierService.notify( 'error', error );
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit(): void {   
    this.carregando_salvar = true;
    let observacao = this.form.value as Observacao;
    observacao.codigo_pessoa = this.codigo_pessoa;
    this.observacaoService.save(observacao, this.codigo_observacao).subscribe((data) => {
      this.obterObservacoes();
      this.notifierService.notify( 'success', 'Observação ATUALIZADA com sucesso.' );
      this.carregando_salvar = false;
    }, (error) => {
      this.carregando_salvar = false;
      this.notifierService.notify( 'error', 'Não foi possível CADASTRAR/ATUALIZAR o registro, ocorreu um erro. ' + error );
    });
  }

  finalizarCadastro(): void {
    this.carregando_finalizar = true;

    this.associadoService.finalizar(this.codigo_pessoa).subscribe(() => {
      this.carregando_finalizar = false;
      this.notifierService.notify('success', 'Cadastro FINALIZADO com sucesso.');
      this.router.navigate(['associado-listar']);
    }, (error) => {
      this.carregando_finalizar = false;
      this.notifierService.notify('error', 'Não foi possível FINALIZAR o cadastro. ' + error);
    });
  }

}
